/**
 * Domain helpers that read shared API types but hold no screen markup. Imports
 * only leaf modules so it stays cycle-free as screens import it.
 */
import { num } from '../components/ui-helpers.js';
import type { ChatCardT, VerdictRowT } from '../data/api.js';

/** Human label for a mutating confirmation card (HS2-ZXJJSS). */
export function describeCard(card: ChatCardT): string {
  if (card.tool === 'propose_line_items') {
    const items = (card.data as { lineItems?: { description?: string }[] }).lineItems ?? [];
    const names = items.map((i) => i.description ?? '').filter((s) => s !== '');
    return `Add ${String(items.length)} line item${items.length === 1 ? '' : 's'}${names.length > 0 ? `: ${names.join('; ')}` : ''}`;
  }
  if (card.tool === 'propose_assumption_change') {
    const d = card.data as { field?: string; value?: string | number };
    return `Change assumption "${d.field ?? '?'}" to ${String(d.value ?? '?')}`;
  }
  if (card.tool === 'add_context_entry') {
    const d = card.data as { text?: string };
    return `Save fact: ${d.text ?? ''}`;
  }
  return `Proposed ${card.tool.replace(/^propose_/, '').replace(/_/g, ' ')}`;
}

/** Estimated over-market spend for a line: (best quote − benchmark mid) × qty. */
export function impactOf(v: VerdictRowT, qty: number): number {
  const best = num(v.bestQuotePrice);
  const low = num(v.benchmarkLow);
  const high = num(v.benchmarkHigh);
  if (best === null || low === null || high === null) return 0;
  const mid = (low + high) / 2;
  return Math.max(0, Math.round((best - mid) * qty));
}
